module.exports = __webpack_public_path__ + "img/codes.b2fd7ff2.svg";